import { render, staticRenderFns } from "./domain-info-panel.vue?vue&type=template&id=b48f081a"
import script from "./domain-info-panel.ts?vue&type=script&lang=ts&external"
export * from "./domain-info-panel.ts?vue&type=script&lang=ts&external"
import style0 from "./domain-info-panel.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports